import React from 'react'
import { Route } from 'react-router'
import Loadable from 'react-loadable'
import loading from 'components/ui/Loader/Loader'


const TestPage = Loadable({ loader: () => import('layers/health/pages/TestPage/TestPage'), loading })


export default (links) => (
  <Route>
    <Route path={links.health} component={TestPage} />

    {/*<Redirect path={`${links.root}/*`} to={links.root} />*/}
  </Route>
)
